import Modal from 'react-modal';
import { useFirestoreOrderBy } from '../../firebase/useFirestore';

const AddTargetgroupsModal = ({
  setAddTargetgroupsModalOpen,
  addTargetgroupsModalOpen,
  addTargetgroups,
  selectedTargetgroups,
  setSelectedTargetgroups
}) => {
  // Firestore
 const targetgroups = useFirestoreOrderBy('Stakeholders', 'Position', 'asc');

  // Modal settings
  Modal.setAppElement('#root');

  const modalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  const isGroupSelected = (groupId) =>
    selectedTargetgroups.some((g) => g.ID === groupId);

  const handleToggleGroup = (group) => {
    setSelectedTargetgroups((prev) => {
      const alreadySelected = prev.some((g) => g.ID === group.ID);
      if (alreadySelected) {
        // remove
        return prev.filter((g) => g.ID !== group.ID);
      }
      // add
      return [...prev, group];
    });
  };

  const allSelected =
    targetgroups &&
    targetgroups.length > 0 &&
    targetgroups.every((tg) =>
      selectedTargetgroups.some((sel) => sel.ID === tg.ID)
    );

  const handleToggleAll = () => {
    if (!targetgroups || targetgroups.length === 0) return;
    if (allSelected) {
      // deselect all
      setSelectedTargetgroups([]);
    } else {
      // select all
      setSelectedTargetgroups(targetgroups);
    }
  };

  return (
    <Modal
      isOpen={addTargetgroupsModalOpen}
      onRequestClose={() => setAddTargetgroupsModalOpen(false)}
      style={modalStyles}
      contentLabel="Add target groups Modal"
    >
      <div>
        <div id="delete-modal-text-container">
          <h1>Doelgroep synchroniseren</h1>
          <h2>Selecteer de doelgroepen die u wilt synchroniseren</h2>

          {/* Select-all row */}
          {/* {targetgroups && targetgroups.length > 0 && (
            <div
              id="portfolio-syncs-add-question-modal-effects-container"
            >
              <input
                type="checkbox"
                id="select-all-targetgroups"
                checked={allSelected}
                onChange={handleToggleAll}
              />
              <label
                htmlFor="select-all-targetgroups"
              >
                Alle doelgroepen selecteren
              </label>
            </div>
          )} */}

          {/* Individual targetgroups */}
          {targetgroups && targetgroups.length > 0 &&
            targetgroups.map((group) => (
              <div
                key={group.ID}
                id="portfolio-syncs-add-targetgroup-modal-effects-container"
              >
                <input
                  type="checkbox"
                  id={`tg-${group.ID}`}
                  checked={isGroupSelected(group.ID)}
                  onChange={() => handleToggleGroup(group)}
                />
                <label htmlFor={`tg-${group.ID}`}>
                  {group.Organisation}
                </label>
              </div>
            ))}

          {targetgroups && targetgroups.length === 0 && (
            <p>Er zijn nog geen doelgroepen beschikbaar om te synchroniseren.</p>
          )}
        </div>

        <div id="delete-modal-button-container">
          <button
            id="delete-modal-delete-button"
            onClick={() => setAddTargetgroupsModalOpen(false)}
          >
            Annuleren
          </button>
          <button onClick={addTargetgroups}>
            Opslaan
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AddTargetgroupsModal;
